import loadable from '@loadable/component';

export default loadable(() =>
  import(
    /* webpackChunkName: "PaymentRequestsCreateModal" */ './containers/Root'
  ),
);
export { default as reducer } from './reducer';
export { STATE_NAME } from './constants';
